import {CacheableWrapper} from '@aboutyou/cacheable-components';
import {
  CACHEABLE_USP_PLACEHOLDER,
  useFullScreenView,
  UspBanner,
} from '@aboutyou/logic-components';
import {useIsCheckoutPage} from '@aboutyou/router';
import React from 'react';
import {AppProviders} from '../../../AppProviders';

export const ConditionalUspBanner = () => {
  const isCheckoutPage = useIsCheckoutPage();
  const {isHeaderDisabled} = useFullScreenView();
  if (isHeaderDisabled) {
    return null;
  }

  if (isCheckoutPage) {
    return null;
  }
  return (
    <CacheableWrapper placeholder={CACHEABLE_USP_PLACEHOLDER}>
      <UspBanner />
    </CacheableWrapper>
  );
};

export const CacheableUspBanner = () => {
  return (
    <AppProviders>
      <UspBanner />
    </AppProviders>
  );
};
